export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/notice.8b121f9e-99e70b.svg";